var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 4.28568H2.35125L5.076 1.17137C5.3415 0.868512 5.298 0.417795 4.98 0.16565C4.66125 -0.0872084 4.18875 -0.0457795 3.924 0.25708L0.174 4.54282C0.14475 4.57639 0.12975 4.61568 0.108 4.65282C0.09 4.68282 0.06825 4.70854 0.05475 4.74139C0.021 4.82354 0.00075 4.90997 0.00075 4.99711C0.00075 4.99782 0 4.99925 0 4.99997C0 5.00068 0.00075 5.00211 0.00075 5.00282C0.00075 5.08997 0.021 5.1764 0.05475 5.25854C0.06825 5.2914 0.09 5.31711 0.108 5.34711C0.12975 5.38426 0.14475 5.42354 0.174 5.45711L3.924 9.74286C4.0725 9.91214 4.2855 10 4.5 10C4.6695 10 4.83975 9.94571 4.98 9.83428C5.298 9.58214 5.3415 9.13142 5.076 8.82856L2.35125 5.71426H11.25C11.664 5.71426 12 5.39426 12 4.99997C12 4.60568 11.664 4.28568 11.25 4.28568Z",
    fill: "#005384"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLeftArrow);
export default __webpack_public_path__ + "static/media/ic-left-arrow.227ab1b5e426ade5be25006a2d6e32f9.svg";
export { ForwardRef as ReactComponent };